// extracted by mini-css-extract-plugin
export default {"actionButton":"vbsH0Q","primary":"ZXFWnc","secondary":"Depzfn","primaryActionMargin":"W1aAKt"};